export class Horse_show {
	id: string;
	number: number;
	name: string;
	location: string;
	short_name: string;
	credit_prize_money: string;
	start_date: Date;
	end_date: Date;
	competition_organizer_id: string;
	competition_organizer_name: string;
	competition_organizer_short_name: string;
	closed: boolean;
	hidden: boolean;
	allow_online_reg: boolean;
  declaration_available: boolean;
	allow_entry_with_access_code: boolean;
	allow_edit_entry: boolean;
	allow_sign_ups: boolean;
	message: string;
	message_type: string;
	pinned: boolean;
	last_modified: Date;
	waiver_id: string;
	additional_waiver_ids: string[];
	collect_entry_fees: boolean;
	allow_nominate_rider: boolean;
	allow_barn_account: boolean;
	venue_id: string;
	venue_name: string;
	has_additional_terms: boolean;
	additional_terms_title: string;
	additional_terms_text: string;
	federation_code: string;
	account_message: string;
	circuit_id: string;
	circuit_name: string;
	allow_copy_entry: boolean;
	allow_acceptance_via_check: boolean;
	convenience_fee_rate: number;
	collect_convenience_fee: boolean;

	collect_separate_epf: boolean;
    collect_only_epf: boolean;
    epf_amount: number;
    epf_currency: string;

    country_iso_3: string;

    payment_gateway: string;

	allow_submission_with_cheque_pledge: string;
	cheque_pledge_text: string;

	restrict_capacity: boolean;
	capacity: number;
	receipt_message: string;

	no_payment_required: boolean;

	multidiscipline: boolean;

	disciplines: string[] = [];

	biosecurity_protocol_id: string;
	biosecurity_protocol_active: boolean;

	//Not set on initial load of object. Property set by separate process under some circumstances where it's relevant
	restricted_event_unlocked: boolean;

	//Convenience property
	selected: boolean;

	constructor(values: Object = {}) {
		Object.assign(this, values);
		this.restricted_event_unlocked = false;
		this.selected = false;
	}

}
